// Bulk emails (4.11, 4.12; job L-09, Find walk-through round 2, item 85). Ask's "Email them" is for people she
// already knows (her contacts, network and customers), and their bulk emails live in ReConnect › Bulk emails. A cold
// list (firms Find brought in: picked from the prospect database or found by a Find search) is refused in Ask with a
// plain message pointing to Find campaigns, which check each firm and keep to her pace.
import type { Crm } from "./crm";
import type { ActionPreview } from "./askActions";

export const BULK_EMAILS_PATH = "/reconnect/actions/bulk-emails";
export const FIND_CAMPAIGNS_PATH = "/campaigns/list";

type FirmLike = Record<string, unknown> | null | undefined;

/** A target firm Find brought in for cold outreach: from the prospect database, a Find search (2.x) or the Find flavour. */
export function isColdFirm(o: FirmLike): boolean {
  if (!o) return false;
  if (o.known_contact === true) return false;
  // Her network (referrers, partners, lenders, customers) is never a cold list, whatever brought the firm in.
  if (typeof o.kind === "string" && o.kind !== "target") return false;
  return Boolean(o.ref_firm_id) || o.flavour === "find" || /^2\./.test(String(o.source ?? ""));
}

export type EmailRoute = { kind: "cold"; cold: number; of: number } | { kind: "known" };

/** Where an Ask email to this list belongs, from the firms of the people included (checked on the preview's sample). */
export function emailRoute(firms: FirmLike[]): EmailRoute {
  const cold = firms.filter(isColdFirm).length;
  return cold > 0 ? { kind: "cold", cold, of: firms.length } : { kind: "known" };
}

/** The firms behind the preview's sample (at most 10 reads, this business only through Crm). */
export async function sampleFirms(crm: Pick<Crm, "organisation">, p: Pick<ActionPreview, "sample">): Promise<FirmLike[]> {
  const ids = [...new Set(p.sample.map((r) => r.organisation_id).filter((x): x is string => Boolean(x)))].slice(0, 10);
  const rows = await Promise.all(ids.map((id) => crm.organisation(id).catch(() => null)));
  return rows as unknown as FirmLike[];
}

/** The plain message for each route. */
export function emailRouteText(r: EmailRoute): string {
  if (r.kind === "known") return "These are people you already know, so this goes out as a bulk email from ReConnect. Each email waits for your approval.";
  return "Ogma doesn't send bulk emails to firms you don't know yet, and this list includes firms Find brought in. Reach them through a Find campaign: it checks each firm first and keeps to your pace.";
}
